import React, {useState} from 'react';
import { Col, Row, Nav, Card, Image, Button, Table, Dropdown, ProgressBar, Pagination, ButtonGroup } from '@themesberg/react-bootstrap';
import EditModal from "./DataEditForm";
import {Routes} from "../../routes";
import {useHistory} from "react-router-dom";

const DataTable = ({data, onAdd}) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const navigate = useHistory();
    // Funciones de acciones (ver, editar, eliminar)
    const handleView = (id) => {
        // Función para redirigir a la página de detalle
            navigate.push(Routes.DetailOptionPage.path.replace(':id', id)); // Reemplaza :id con el valor real
    };

    const handleEdit = (id) => {
        setSelectedId(id);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedId(null);
    };

    const handleDelete = (id) => {
        const confirmDelete = window.confirm(`¿Estás seguro de eliminar el registro con ID: ${id}?`);
        if (confirmDelete) {
            alert(`Registro con ID: ${id} eliminado`);
        }
    };

    return (
        <div>
        <Table striped bordered hover>
            <thead>
            <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Value</th>
                <th>Acciones</th>
            </tr>
            </thead>
            <tbody>
            {data.map(item => (
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.value}</td>
                    <td>
                        <Button variant="info" size="sm" onClick={() => handleView(item.id)}>
                            Ver
                        </Button>{' '}
                        <Button variant="warning" size="sm" onClick={() => handleEdit(item.id)}>
                            Editar
                        </Button>{' '}
                        <Button variant="danger" size="sm" onClick={() => handleDelete(item.id)}>
                            Eliminar
                        </Button>
                    </td>
                </tr>
            ))}
            </tbody>
        </Table>
    <EditModal id={selectedId} show={showModal} handleClose={handleCloseModal} onAdd={onAdd}/>
        </div>
    );
};

export default DataTable;